import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13c22a9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row h-full w-full" }
const _hoisted_2 = { class: "workload-view-header bg-System/app_white px-[24px] w-full h-fit flex flex-row z-10 justify-start" }
const _hoisted_3 = { class: "w-full min-w-[830px] max-w-[1624px] mx-auto" }
const _hoisted_4 = { class: "header-container flex w-full justify-between" }
const _hoisted_5 = { class: "row items-center" }
const _hoisted_6 = { class: "header-title text-Text/text_high" }


import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import UserNotifications from '@/components/common/userNotifications/userNotifications.vue';
import { useWorkloadViewDataProvider } from '../workloads.helpers';
import { useMinimizedHeader } from './minimized-header.helpers';
import workloadViewHeader from './workload-view-header.vue';
import workloadViewTabs from './workload-view-tabs.vue';

type Props = {
  id: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view',
  props: {
    id: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
}



const [minimized] = useMinimizedHeader();
useWorkloadViewDataProvider(props.id);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(IbxScopedCss, {
    class: "workload-view",
    style: {"margin":"0 auto","display":"inline-flex","flex-direction":"column","position":"fixed"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('workloads.details.title')), 1)
              ]),
              _createVNode(UserNotifications)
            ]),
            _createVNode(workloadViewHeader),
            _createVNode(workloadViewTabs)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["workload-view-container w-full overflow-auto incredi-scroll-bar-wide", {
          minimized: _unref(minimized),
        }])
        }, [
          _createVNode(_component_router_view)
        ], 2)
      ])
    ]),
    _: 1
  }))
}
}

})